
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns0d61b657bda36c95bfcc880de6433d2den from './en.yaml'
            i18n.addResourceBundle('en', '0d61b657bda36c95bfcc880de6433d2d', flattenObject(ns0d61b657bda36c95bfcc880de6433d2den), true, true);
        
        export default '0d61b657bda36c95bfcc880de6433d2d';
    